import { createApi } from '@reduxjs/toolkit/query/react';

import { Category, CategoryStrapi, CategoryWiseProductsResponse } from '@/types/Category';
import { ProductStrapi } from '@/types/Product';
import { CategoryDetailsFilterPayload } from '@/types/ProductFIlters';

import { flatMapProductsAdapter } from '../adapters';
import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const categoryDetailsApi = createApi({
  reducerPath: 'categoryDetailsApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({
    basePath: '',
    useStrapiServer: true,
    cache: 'no-store',
  }),
  tagTypes: ['AllCategories', 'CategoryDetails'],
  endpoints: builder => ({
    getAllCategories: builder.query<{ categories: Array<Category> }, void>({
      query: () => ({
        url: '/pawtree/categories',
        headers: {
          Origin: globalThis.window?.location?.origin,
        },
        next: { tags: ['AllCategories'] },
      }),
      transformResponse: (response: { data: { categories: Array<Category> } }, meta, arg) => response.data,
      providesTags: ['AllCategories'],
    }),
    getCategoryDetails: builder.query<
      { Products: ProductStrapi[]; Category: CategoryStrapi },
      CategoryDetailsFilterPayload
    >({
      query: ({ categoryId, queryString }) => ({
        url: `/api/categories/${categoryId}?${queryString}`,
        next: { tags: ['CategoryDetails'] },
      }),

      transformResponse: (response: { data: CategoryWiseProductsResponse }, meta, arg) =>
        flatMapProductsAdapter(response.data),
      providesTags: ['CategoryDetails'],
    }),
  }),
});

export const { useGetCategoryDetailsQuery, useGetAllCategoriesQuery } = categoryDetailsApi;
